import { Box, Card, IconButton, LinearProgress, styled, Typography } from "@mui/material";

export const FileUploadArea = styled(Box)`
  width: 100%;
  aspect-ratio: 16/9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed
    ${({ theme, isDragOver }) =>
      isDragOver ? theme.palette.primary.main : theme.palette.divider};
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s ease-in-out;
  flex-shrink: 1;
  position: relative;
`;

export const Chunk = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

export const Row = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const VerticalChunk = styled(Box)`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
`;

export const OverflowTypography = styled(Typography)`
  text-wrap: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
`;

export const LoadingBar = styled(LinearProgress)`
  margin-block: 16px -16px;
  width: 120%;
  margin-inline-start: -20px;
`;

export const FileCard = styled(Card)`
  width: 100%;
  padding: ${({ theme }) => theme.spacing(2)};
`;

export const RelativeRow = styled(Row)`
  position: relative;
`;

export const FileVerticalChunk = styled(VerticalChunk)`
  width: 90%;
`;

export const FileInfoChunk = styled(Chunk)`
  overflow: hidden;
  align-items: flex-start;
  gap: 0;
`;

export const RemoveIconButton = styled(IconButton)`
  position: absolute;
  right: -14px;
  top: 0;
`;
